/** Mounts inside `ReactFlowProvider` so `useStoreApi()` is available. */
import type { ReactNode } from 'react'
import { CanvasFloatingLayerContext, useCanvasFloatingLayerRegistrar } from './canvasAnchoredOverlay'

export default function CanvasFloatingLayerHost({ children }: { children: ReactNode }) {
  const registerOpenLayer = useCanvasFloatingLayerRegistrar()
  return (
    <CanvasFloatingLayerContext.Provider value={{ registerOpenLayer }}>{children}</CanvasFloatingLayerContext.Provider>
  )
}
